<script>
    import { state, res } from './stores.js';

    let playerStyles = ['color: white; background-color: black', 'color: black; background-color: white;'];
</script>

<div>
    <div class="row">
        <div class="head"></div>
            {#each Array(10) as _, num}
                <div class="vp" class:domination_text={num == 9}>
                    {#if $res.trackVP[num] == Infinity}
                        WIN
                    {:else}
                        {$res.trackVP[num]} VP
                    {/if}
                </div>
            {/each}
    </div>
    {#each $res.trackTypes as t}
        <div class="row">
            <div class="head"><img style="width: 1em; height: 1em;" src="{t}.png" />&nbsp;{t[0].toUpperCase()}{t.slice(1)}:</div>
            {#each Array(10) as _, num}
                <div class="space" class:domination={num == 9}>
                    {#each $state.players as p, i}
                        {#if p[t] == num}
                            <div class="block" style={playerStyles[i]}>{p.captain}</div>
                        {/if}
                    {/each}
                </div>
            {/each}
        </div>
    {/each}
</div>

<style>
    .domination {
        background-color: red;
    }

    .domination_text {
        color: red;
    }

    .head {
        width: 15vmin;
        min-width: 10em;
        display: flex;
    }

    .row {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        font-weight: bold;
    }

    .space {
        display: flex;
        flex-direction: column;
        width: 10vmin;
        height: 10vmin;
        border: 2px solid black;
    }

    .vp {
        width: 10vmin;
        text-align: center;
        border: 2px solid rgba(0,0,0,0)
    }

    .block {
        height: 3vmin;
        margin: auto;
        padding: 0.5vmin;
    }
</style>